var t = String,
  r = function r(_r) {
    try {
      return t(_r);
    } catch (t) {
      return "Object";
    }
  };
export { r as t };